export default [
  {
    name: "Eken, HS",
    id: "1df1bbea-a0b3-4fe8-9897-a0a2579d0e33",
  },
  {
    name: "Linden, HS",
    id: "047e146f-400e-410f-bacd-cdddd51752e4",
  },
  {
    name: "Björken",
    id: "e2d1da6e-c090-4d6e-a818-e4bdf34a217f",
  },
  {
    name: "Almen",
    id: "a11b8b9c-5936-4221-b0a7-77706e6446aa",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.campusUS.house421.id
})) */
